import { render, staticRenderFns } from "./AssignBookingDriver.vue?vue&type=template&id=c4598fb8&"
import script from "./AssignBookingDriver.vue?vue&type=script&lang=js&"
export * from "./AssignBookingDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports